import { useMutation } from "@tanstack/react-query";
import { createReceiptPdfV2 } from "apis";
import { serializeErrorForTracking, track } from "../../utils/tracking";
import { ReceiptObjectForPdf } from "../../receiptOnClient/GeneratePDFOnClient";

type CreateReceiptPdfV2Input = {
  pdfObject: ReceiptObjectForPdf;
};

const useCreateReceiptPdfV2 = () => {
  return useMutation(
    async ({ pdfObject }: CreateReceiptPdfV2Input) => {
      return await createReceiptPdfV2({ pdfObject  });
    },
    {
      onSuccess: (response) => {
        track("CREATE_RECEIPT_PDF_V2", {
          success: String(response?.success),
          receiptUrl: String(response?.receipt_url || ""),
        });
      },
      onError: (error: any) => {
        console.error("ERROR ======> useCreateReceiptPdfV2", error);
        track("ERROR", {
          on: "receipt-flag-off-flow-v2",
          what: serializeErrorForTracking(error),
        });
      },
    }
  );
};

export default useCreateReceiptPdfV2;
